export default function stringifyStoryboardRequest(data) {
  if (data?.storyboard) {
    data = { ...data, storyboard: JSON.stringify(data.storyboard) };
  }
  return data;
}
